import { KeymapContext } from "@features/keymap/KeymapContext"
import { KeymapContextValue } from "@features/keymap/types"
import logger from "@utils/logger"
import { useContext } from "react"

const fallbackKeymap: KeymapContextValue = {
  regKey: () => {},
  unregKey: () => {},
  getKeymaps: () => ({ list: [], byId: new Map() }),
}

export const useKeymap = () => {
  const context = useContext(KeymapContext)
  if (!context) {
    if (import.meta.env.DEV) {
      logger.error("useKeymap called outside KeymapProvider. Falling back to noop keymap.")
    }
    return fallbackKeymap
  }
  return context
}
